import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { collection, getDocs, orderBy, query } from 'firebase/firestore';
import { db } from '../firebase/firebase';
import AOS from 'aos';
import 'aos/dist/aos.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import Footer from '../components/Footer';
import Header from '../components/Header';


// You would import this in your actual implementation
// import pageTitleBg from '../assets/img/page-title-bg.webp';

const BlogList = () => {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [backgroundLoaded, setBackgroundLoaded] = useState(false);
  
  // For pagination like in the second component
  const [currentPage, setCurrentPage] = useState(1);
  const totalPages = 5; // This can be calculated based on your actual post count
  
  useEffect(() => {
    // Initialize AOS for animations
    AOS.init({ duration: 1000, once: true });
    
    // Load background image
    const bgImage = new Image();
    bgImage.src = "assets/img/page-title-bg.webp";
    
    if (bgImage.complete) {
      setBackgroundLoaded(true);
    } else {
      bgImage.onload = () => {
        setBackgroundLoaded(true);
      };
      
      bgImage.onerror = () => {
        console.error('Failed to load background image');
      };
    }
    
    const fetchPosts = async () => {
      try {
        const postsQuery = query(
          collection(db, 'blogPosts'), 
          orderBy('createdAt', 'desc')
        );
        
        const querySnapshot = await getDocs(postsQuery);
        const postsData = querySnapshot.docs.map(doc => ({
          id: doc.id,
          ...doc.data()
        }));
        
        setPosts(postsData);
        setLoading(false);
      } catch (error) {
        console.error("Error fetching blog posts:", error);
        setLoading(false);
      }
    };

    fetchPosts();
  }, []);
  
  const handlePageChange = (pageNumber) => {
    if (pageNumber < 1 || pageNumber > totalPages) return;
    setCurrentPage(pageNumber);
  };

  return (
    <div className="main">

      
        <link rel="canonical" href="https://www.zaoafrika.co.ke/" />
        <title>Zao Afrika | Empowering Farmers, Growing Futures</title>
        <meta
          name="description"
          content="Zao Afrika empowers farmers through organic farming, value addition, and access to premium markets. Discover our contract farming, agri-tech solutions, and high-value crop portfolio including chia, flax, quinoa, moringa, avocado, and macadamia. Join us in growing sustainable futures."
        />
    

      <Header />
      {/* Page Title */}
      <div 
        className="page-title dark-background" 
        data-aos="fade" 
        style={{
          backgroundImage: backgroundLoaded ? `url(assets/img/page-title-bg.webp)` : 'none',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          minHeight: '250px',
          backgroundColor: !backgroundLoaded ? '#f0f0f0' : 'transparent'
        }}
      >
        <div className="container position-relative">
          <h1>Blog</h1>
          <p>Stay updated with our latest news and insights.</p>
          <nav className="breadcrumbs">
            <ol>
              <li><Link to="/login">Create</Link></li>
              <li>Blog</li>
            </ol>
          </nav>
        </div>
      </div>

      {/* Blog Posts Section */}
        <section id="blog-posts-2" className="blog-posts-2 section">
          <div className="container">
            {loading ? (
          <div className="text-center">
            <div className="spinner-border text-primary" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
          </div>
            ) : (
          <div className="row gy-4">
            {posts.length > 0 ? (
              posts.map((post) => (
            <div key={post.id} className="col-lg-4">
              <article className="position-relative h-100">
                <div className="post-img position-relative overflow-hidden">
              <img src={post.imageUrl || "assets/img/blog/Blog1.png"} className="img-fluid" alt={post.title} />
                </div>
                <div className="meta d-flex align-items-end">
              <span className="post-date">
                <span>{new Date(post.createdAt?.toDate()).getDate()}</span>
                {new Date(post.createdAt?.toDate()).toLocaleString('default', { month: 'long' })}
              </span>
              <div className="d-flex align-items-center">
                <i className="bi bi-person" /> 
                <span className="ps-2">{post.author}</span>
              </div>
              <span className="px-3 text-black-50">/</span>
              <div className="d-flex align-items-center">
                <i className="bi bi-folder2" /> 
                <span className="ps-2">{post.category || 'Uncategorized'}</span>
              </div>
                </div>
                <h3 className="post-title">{post.title}</h3>
                {/* Post summary added below category */}
                {post.summary && (
              <p className="post-summary mt-2" style={{ fontSize: "0.9rem", color: "#6c757d" }}>
                {post.summary}
              </p>
                )}
                <div className="post-content d-flex flex-column">
              
              <Link to={`/blogdetails/${post.id}`} className="readmore stretched-link">
                <span>Read More</span>
                <i className="bi bi-arrow-right" />
              </Link>
                </div>
              </article>
            </div>
              ))
            ) : (
              <div className="col-12 text-center">
            <h3>No blog posts found</h3>
            <p>Check back soon for new content!</p>
              </div>
            )}
          </div>
            )}
          </div>
        </section>

        {/* Blog Pagination Section */}
      {posts.length > 0 && (
        <section id="blog-pagination" className="blog-pagination section">
          <div className="container">
            <div className="d-flex justify-content-center">
              <ul className="pagination">
                <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                  <button 
                    type="button" 
                    className="page-link" 
                    onClick={() => handlePageChange(currentPage - 1)}
                    disabled={currentPage === 1}
                  >
                    <i className="bi bi-chevron-left" />
                  </button>
                </li>
                {currentPage > 3 && (
                  <>
                    <li className="page-item">
                      <button 
                        type="button" 
                        className="page-link" 
                        onClick={() => handlePageChange(1)}
                      >
                        1
                      </button>
                    </li>
                    <li className="page-item disabled">
                      <span className="page-link">...</span>
                    </li>
                  </>
                )}
                {[
                  Math.max(1, currentPage - 1),
                  currentPage,
                  Math.min(totalPages, currentPage + 1)
                ].map(page => (
                  <li 
                    key={page} 
                    className={`page-item ${page === currentPage ? 'active' : ''}`}
                  >
                    <button 
                      type="button" 
                      className="page-link" 
                      onClick={() => handlePageChange(page)}
                    >
                      {page}
                    </button>
                  </li>
                ))}
                {currentPage < totalPages - 2 && (
                  <>
                    <li className="page-item disabled">
                      <span className="page-link">...</span>
                    </li>
                    <li className="page-item">
                      <button 
                        type="button" 
                        className="page-link" 
                        onClick={() => handlePageChange(totalPages)}
                      >
                        {totalPages}
                      </button>
                    </li>
                  </>
                )}
                <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                  <button 
                    type="button" 
                    className="page-link" 
                    onClick={() => handlePageChange(currentPage + 1)}
                    disabled={currentPage === totalPages}
                  >
                    <i className="bi bi-chevron-right" />
                  </button>
                </li>
              </ul>
            </div>
          </div>
        </section>
      )}

      {/* Call To Action Section */}
      <section id="call-to-action" className="call-to-action section light-background">
        <div className="content">
          <div className="container">
            <div className="row align-items-center">
              <div className="col-lg-6">
                <h3>Subscribe To Our Newsletter</h3>
                <p className="opacity-50">
                  Stay updated with our latest blog posts and agricultural insights!
                </p>
              </div>
              <div className="col-lg-6">
                <form action="forms/newsletter.php" className="form-subscribe php-email-form">
                  <div className="form-group d-flex align-items-stretch">
                    <input 
                      type="email" 
                      name="email" 
                      className="form-control h-100" 
                      placeholder="Enter your e-mail" 
                    />
                    <input 
                      type="submit" 
                      className="btn btn-secondary px-4" 
                      value="Subscribe" 
                    />
                  </div>
                  <div className="loading">Loading</div>
                  <div className="error-message" />
                  <div className="sent-message">
                    Your subscription request has been sent. Thank you!
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Footer */}
              <Footer />
    </div>
  );
};

export default BlogList;